<app-hero></app-hero>
<app-problema></app-problema>
@defer (on viewport; prefetch on idle) {
  <app-claims></app-claims>
} @placeholder {
  <div style="min-height: 320px"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-funcionalidades></app-funcionalidades>
} @placeholder {
  <div style="min-height: 480px"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-para-quien></app-para-quien>
} @placeholder {
  <div style="min-height: 280px"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-confianza></app-confianza>
} @placeholder {
  <div style="min-height: 300px"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-faq></app-faq>
} @placeholder {
  <div style="min-height: 400px"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-interes></app-interes>
} @placeholder {
  <div style="min-height: 200px"></div>
}
